import * as React from "react";
import AdminLink from "./AdminLink";

export const Navigator = ({ onNavigate, page, role, user }: any) => {
  return (
    <AdminLink onNavigate={onNavigate} page={page} roles={role} user={user} />
  );
};
